import React, {useCallback, useContext, useEffect, useState} from 'react'
import {AuthContext} from '../context/AuthContext'
import {useHttp} from "../hooks/http.hook"
import config from '../config.json'
import {
    getAuthHeader,
    getMoneyMonthDetailPath,
    objectLang,
    setErrorWindow,
    setGlobalMoneyObject
} from "../functions"
import {LoaderClass} from "./LoaderClass"
import {ModalWin} from "./ModalWin"

export const RemoveLine = () => {

    const auth = useContext(AuthContext)
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const {request, loading} = useHttp()

    const data = useCallback(async () => {
        const lang = objectLang().language
        const l = lang.lang
        const urlParams = new URLSearchParams(window.location.search)
        const nameRecordDB = urlParams.get('nameRecordDB')
        const purpose = urlParams.get('purpose')
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        try {
            const data = await request(
                `${host}/api/money/month/deleting`,
                'DELETE',
                {purpose, nameRecordDB},
                {
                    Authorization: getAuthHeader(auth)
                })

            // if (data.code === 6041) {
            //     window.location.replace(getPathAndQueryParams())
            // }

            if (data.status === 200) {
                setGlobalMoneyObject(data['money'])
                window.location.replace(getMoneyMonthDetailPath())
            } else {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code))
            }

        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }, [request, auth])

    useEffect(() => {
        data().then()
    }, [data])

    if (loading) {
        return <LoaderClass />
    }

    if (!allowed) {
        return (
            <>
                <ModalWin data={dataModal}/>
            </>

        )
    }
}
